import { IsNumber, IsString, IsOptional } from 'class-validator';

export class AkcAgilitySctEntryDto {
  @IsNumber()
  yds: number;

  @IsString()
  regular_jump_height: string;

  @IsNumber()
  @IsOptional()
  regular_sct?: number | string;

  @IsString()
  preferred_jump_height: string;

  @IsNumber()
  @IsOptional()
  preferred_sct?: number | string;
}

export interface AkcAgilitySctDto {
  [key: string]: AkcAgilitySctEntryDto[];
}
